import { createFileRoute } from "@tanstack/react-router";
import WebseitencheckPage from "@/pages/WebseitencheckPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/webseitencheck")({
  head: () =>
    buildRouteHead({
      title: "Kostenloser Webseitencheck & Analyse | Enno & Jens",
      description:
        "Kostenloser Webseitencheck: Performance-Check, Responsive-Check, SEO-Basisanalyse sowie Prüfung von Impressum und Datenschutz. Jetzt anfragen!",
      path: "/webseitencheck",
      image: "/images/services/webseitencheck-1024.webp",
      imageAlt: "Kostenloser Webseitencheck",
      imageWidth: 1024,
      imageHeight: 730,
    }),
  component: WebseitencheckPage,
});
